<campus-icon [svgIcon]="icon"></campus-icon>

<dcr-state-layer class="bg-on-surface" [for]="element"></dcr-state-layer>
<dcr-focus-ring [for]="element"></dcr-focus-ring>
